import styled from '@emotion/styled';
import { useState } from 'react';
import { Button } from 'semantic-ui-react';
import { NullableOptionValue, OptionValue } from '../types';
import { Disabled } from './Option';

interface OptionButtonsProps {
	onChange: (value: NullableOptionValue) => void;
	options: readonly OptionValue[];
	defaultValue?: string;
	disabled?: Disabled;
	isInput?: boolean;
}

const ButtonGroup = styled(Button.Group)`
	margin: auto 0;

	&.ui.teal.buttons .button {
		background-color:#00b5ac;
	}

	&.ui.teal.buttons .button.active {
		background-color:#1b756f;
	}
`

const NarrowButton = styled(Button)`
	padding-left: 6px !important;
	padding-right: 6px !important;
`;

const BorderlessButton = styled(Button)`
	border: 0 !important;
	padding: 8px !important;
	box-shadow: initial !important;

	& :hover {
		box-shadow: initial !important;
	}

	&.ui.button.basic:active {
		background: none !important;
	}
`;

export const OptionButtons: React.FC<OptionButtonsProps> = ({ options, onChange, disabled, isInput, defaultValue }) => {
	const [selectedOption, setSelectedOption] = useState<NullableOptionValue>();

	const handleClick = (option: NullableOptionValue) => {
		setSelectedOption(option);
		onChange(option);
	}

	const isDisabled = (value: OptionValue) => {
		if(!disabled) {
			return false;
		}

		return disabled.type === 'option' || (disabled.type === 'value' && !disabled.values.includes(value))
	}

	return (
		<>
			<ButtonGroup size="tiny" color="teal">
				{options.map((option) => (
					<NarrowButton disabled={isDisabled(option)} onClick={() => handleClick(option)} active={(defaultValue || selectedOption)?.toString() === option.toString()} key={option.toString()}>{option.toString()}</NarrowButton>
				))}
			</ButtonGroup>
			{(selectedOption != null || defaultValue) && !isInput && <BorderlessButton onClick={() => handleClick(null)} size="tiny" circular basic icon="cancel" />}
		</>
	);
};
